import { ROUTES } from "@/lib/consts/routes";
import { LoginResult } from "../auth/login";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { EErrorCodes, FAILED_PAGE_MESSAGES } from "@/lib/consts/errors";
import { FAILED_PAGE_QUERY_PARAMS } from "@/lib/consts/params";
import { HttpError } from "@/lib/http-client/types";
import { FailedPageErrorCode } from "@/lib/types/error";
import { resolveFailedPageErrorFromHttpError } from "@/lib/utils/httpError";

const AUTH_FAILED_URL = `${ROUTES.FAILED_LOGIN}?error=auth`;

/**
 * Hard-navigate to shop so we never soft-nav through LoginDocumentShell's
 * black placeholder while ShopClientWrapper chunks load.
 */
export const navigateToShopHard = (path: string = ROUTES.SHOP): void => {
    if (typeof window !== 'undefined') {
        window.location.replace(path);
    }
};

export const redirectBasedOnLoginResponse = (result: LoginResult, router: AppRouterInstance, failedLoginUrl?: string) => {
    if (result === LoginResult.SUCCESS) {
        navigateToShopHard(ROUTES.SHOP);
    } else {
        router.push(failedLoginUrl || AUTH_FAILED_URL);
    }
};

export const navigateToFailedWithMessage = (router: AppRouterInstance, message: keyof typeof FAILED_PAGE_MESSAGES) => {
    router.push(`${ROUTES.FAILED_LOGIN}?${FAILED_PAGE_QUERY_PARAMS.MESSAGE}=${FAILED_PAGE_MESSAGES[message]}`);
};

export const navigateToFailedWithError = (router: AppRouterInstance, error: FailedPageErrorCode) => {
    router.push(`${ROUTES.FAILED_LOGIN}?${FAILED_PAGE_QUERY_PARAMS.ERROR}=${error}`);
};

export const navigateToFailedFromHttpError = (
    router: AppRouterInstance,
    error: HttpError,
    fallbackMessage: keyof typeof FAILED_PAGE_MESSAGES = 'CREATE_ORDER_ERROR',
) => {
    const mappedError = resolveFailedPageErrorFromHttpError(error);
    if (mappedError) {
        navigateToFailedWithError(router, mappedError);
        return;
    }
    navigateToFailedWithMessage(router, fallbackMessage);
};
